/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { ReduxUtils } from '@spm/core';

import { POST_SUBMITTED_APPLICATIONS_APPLICATION_PROGRAMS_ACES_WITHDRAWAL_REQUEST } from './actionTypes';

import { postSubmittedApplicationsApplicationProgramsAcesWithdrawalRequestUtil } from './utils';

/**
 * Contains the action creator functions that update the ACESWithdrawal slice of the store.
 *
 * @namespace ACESWithdrawalActions
 */
export default class actions {
  /**
   * Calls the api and dispatches the results to the store.
   * api: /v1/ua/submitted_applications/{application_id}/application_programs/{application_program_id}/aces_withdrawal_request
   *
   * @param {string} application_id.
   * @param {string} application_program_id.
   * @param {NewUAWithdrawalRequest} data object that will be posted to the api
   * @param {function} callback function to call once this function has finished
   * @function
   * @memberof ACESWithdrawalActions
   */
  static postSubmittedApplicationsApplicationProgramsAcesWithdrawalRequest = (
    dispatch,
    application_id,
    application_program_id,
    newUAWithdrawalRequest,
    callback
  ) => {
    ReduxUtils.generateAction(
      dispatch,
      postSubmittedApplicationsApplicationProgramsAcesWithdrawalRequestUtil.bind(
        null,
        application_id,
        application_program_id,
        newUAWithdrawalRequest
      ),
      POST_SUBMITTED_APPLICATIONS_APPLICATION_PROGRAMS_ACES_WITHDRAWAL_REQUEST,
      callback
    );
  };

  /**
   * Dispatches the data to the store to reset the data cached from a call to postSubmittedApplicationsApplicationProgramsAcesWithdrawalRequest.
   *
   * @param {function} dispatch
   * @param {Object} data object to be set in the store.
   * @function
   * @memberof ACESWithdrawalActions
   */
  static resetPostSubmittedApplicationsApplicationProgramsAcesWithdrawalRequest = (
    dispatch,
    data
  ) => {
    const json = {
      type: POST_SUBMITTED_APPLICATIONS_APPLICATION_PROGRAMS_ACES_WITHDRAWAL_REQUEST.successAction,
      payload: data,
    };
    dispatch(json);
  };

  /**
   * Dispatches the data to the store to reset the error cached from a call to postSubmittedApplicationsApplicationProgramsAcesWithdrawalRequest.
   *
   * @param {function} dispatch
   * @function
   * @memberof ACESWithdrawalActions
   */
  static resetPostSubmittedApplicationsApplicationProgramsAcesWithdrawalRequestError = dispatch => {
    ReduxUtils.resetErrorAction(
      dispatch,
      POST_SUBMITTED_APPLICATIONS_APPLICATION_PROGRAMS_ACES_WITHDRAWAL_REQUEST.failureAction
    );
  };
}
